import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  GdaCircleLogo,
  Link,
  TranslationProvider,
} from '@resy/ui-kitchen';

import Close from '../../svg/dynamic/close.svg';

import './GDAConciergeBooking.scss';

export default function GDAConciergeBooking({
  closeModal,
}) {
  return (
    <div className="GdaConciergeBooking">
      <div className="GdaConciergeBooking__Header">
        <Button
          onClick={closeModal}
          variant="no-style"
          className="GdaConciergeBooking__Close"
          data-test-id="gda_concierge_booking-button-close"
        >
          <Close />
        </Button>
      </div>
      <div className="GdaConciergeBooking__Body">
        <div className="GdaConciergeBooking__logo">
          <GdaCircleLogo
            width="76"
            height="76"
            className="GdaConciergeBooking__Logo-Primary"
          />
        </div>
        <div className="GdaConciergeBooking__copy">
          <TranslationProvider
            className="GdaConciergeBooking__headline"
            translationKey="concierge_booking.headline"
          >
            <div>
              This venue reserves some tables exclusively for Global Dining Access Members.
            </div>
          </TranslationProvider>
          <TranslationProvider
            className="GdaConciergeBooking__description"
            translationKey="concierge_booking.description"
          >
            <div>
              Members can book exclusive reservations by calling the number on the back of their card. Terms Apply.
            </div>
          </TranslationProvider>
        </div>
      </div>
      <div className="GdaConciergeBooking__CTAS">
        <Link
          className="GdaConciergeBooking__CTA"
          variant="gda-button-primary"
          href="/global-dining-access"
          onClick={closeModal}
        >
          <TranslationProvider translationKey="learn_more">
            <div>Learn more</div>
          </TranslationProvider>
        </Link>
        <Button
          className="GdaConciergeBooking__CTA"
          variant="gda-secondary"
          data-test-id="gda_concierge_booking-button-dismiss"
          onClick={closeModal}
        >
          <TranslationProvider translationKey="button_dismiss">
            <div>Dismiss</div>
          </TranslationProvider>
        </Button>
      </div>
    </div>
  );
}

GDAConciergeBooking.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

GDAConciergeBooking.displayName = 'GDAConciergeBooking';
